module.exports = __webpack_public_path__ + "static/media/f16.5bd7b0cd.webp";